import { render, staticRenderFns } from "./CreditApplicationFeedbackForm.vue?vue&type=template&id=08b2bf8d"
import script from "./CreditApplicationFeedbackForm.vue?vue&type=script&lang=js"
export * from "./CreditApplicationFeedbackForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports